export function getValidationMessagesModalContent(messages, title = null) {
    return {
        title: title || 'An error occured',
        buttonText: 'OK',
        body:
            <ul className="list-group">
                {messages.map((error, index) => <li key={index} className="list-group-item" style={{ fontSize: '16px' }}>{error}</li>)}
            </ul>
    };
}

export function currencyFormat(num) {
    if (!num) {
        return '';
    } else {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
}

export function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export function formatZipCode(value, country) {
    if (!value) return value;
    const zip = value.replace(/[^\w]/g, '');
    const zipLength = zip.length;
    if (country == "US") {
        if (zipLength <= 5) {
            return zip;
        }
        else {
            return `${zip.slice(0, 5)}-${zip.slice(5, 9)}`;
        }
    }
    else if (country == "CA") {
        if (zipLength <= 3) {
            return zip;
        }
        else {
            return `${zip.slice(0, 3)}-${zip.slice(3, 6)}`;
        }
    }
}